import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const id = hash.replace('#', '');
            const timer = window.setTimeout(() => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 50);
            return () => window.clearTimeout(timer);
        }
        window.scrollTo(0, 0);
        return undefined;
    }, [pathname, hash]);
    return null;
}
